// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 539) return "js/blocks/news-and-events/539.js";
	// return url for filenames based on template
	return undefined;
};